import React from 'react';
import { Controller } from "react-hook-form";
import { formatPhone } from "../utilities/formatInput";

export default function PhoneNumber(props) {
    const control = props?.control;

    return (
        <React.Fragment>
            <div className="form-group">
                <label htmlFor={props.htmlFor}>{props.label}
                    {
                        props.isStrong ?
                            <strong className="text-primary">*</strong>
                            : null
                    }
                </label>
                <Controller
                    name={props.name}
                    control={control}
                    rules={props.requiredObj}
                    render={({ field: { onChange, value, ref, name, onBlur } }) => (
                        <input
                            ref={ref}
                            type={props.type}
                            name={name}
                            id={props.name}
                            className="form-control"
                            placeholder={props.placeholder}
                            value={value ?? ''}
                            onBlur={onBlur}
                            onChange={(event) => onChange(formatPhone(event.target.value))}
                        />
                    )}
                />
                <small id={props.id} className="text-primary">
                    {props?.errMsg}
                </small>
            </div>
        </React.Fragment>
    );
}
